import * as React from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';
import { logIn } from '../../../../api/Auth';
import { browserHistory } from '../../../../utilities/history';

import { setTokens } from '../../../../utilities/identity';
import { getSourceData } from '../../../../utilities/sourceData';
import { unformatPhoneNumber } from '../../../../utilities/Utils';
import Button from '../../../common/form/Button';
import FormInput from '../../../common/form/Input';
import FormPhoneInput from '../../../common/form/PhoneInput';
import FormValidationDisplay from '../../../common/form/ValidationDisplay';
import LoadingOverlay from '../../../common/LoadingOverlay';
import { prospectPages, prospectPath } from '../ProspectRouter';
import { DualRoutedProps, TourPage, tourSignupPath } from '../signup/TourRouter';

interface Props extends DualRoutedProps {}

const LoginPage = (props: Props) => {
    const sourceData = getSourceData();
    const [phoneNumberInput, setPhoneNumberInput] = useState<string>(sourceData.phone || '');
    const [passwordInput, setPasswordInput] = useState<string>('');
    const [errorMessage, setErrorMessage] = useState<string | undefined>('');
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [wasFormValidated, setWasFormValidated] = useState(false);

    const propertySlug = props.match.params.propertySlug;

    let formControl: HTMLFormElement | null;

    const handleLogin = async () => {
        setIsLoading(true);

        let loginResult = await logIn(phoneNumberInput, passwordInput);

        if (!loginResult.success || !loginResult.data) {
            setIsLoading(false);
            setErrorMessage(loginResult.error);
            return false;
        }

        setTokens(loginResult.data.jwt, loginResult.data.refreshToken);

        let destinationPath = propertySlug
            ? tourSignupPath(propertySlug)(TourPage.GuestCard)
            : prospectPath(prospectPages.welcome);
        if (
            props.history.location &&
            props.history.location.state &&
            props.history.location.state.from
        ) {
            destinationPath = props.history.location.state.from;
        }

        browserHistory.push(destinationPath);
        return true;
    };

    const handleSubmit = (e: React.SyntheticEvent<HTMLFormElement>) => {
        e.preventDefault();
        e.stopPropagation();

        if (formControl !== null) {
            setWasFormValidated(true);
            if (formControl.checkValidity() === true) {
                handleLogin();
            }
        }
    };

    return (
        <Row className="prospect-auth-form">
            <Col xs={12} lg={propertySlug ? 12 : { offset: 2, size: 8 }}>
                <LoadingOverlay show={isLoading} inBootstrapColumn={true} />

                <section>
                    <h3 className="prospect-signup-header">Sign In</h3>

                    <form
                        ref={form => (formControl = form)}
                        noValidate={true}
                        className={wasFormValidated ? 'was-validated' : ''}
                        onSubmit={handleSubmit}
                    >
                        <FormPhoneInput
                            labelProps={{
                                labelText: undefined
                            }}
                            inputProps={{
                                id: 'phone-number',
                                name: 'phoneNumber',
                                required: true,
                                value: phoneNumberInput,
                                placeholder: 'Your Mobile Number'
                            }}
                            onChange={(_, value) => setPhoneNumberInput(unformatPhoneNumber(value))}
                        />

                        <FormInput
                            labelProps={{
                                labelText: undefined,
                                invalidText: 'Please enter your password'
                            }}
                            inputProps={{
                                id: 'password',
                                name: 'password',
                                placeholder: 'Password',
                                value: passwordInput,
                                type: 'password',
                                required: true
                            }}
                            onChange={(_, value) => setPasswordInput(value.toString())}
                        />

                        <div className="forgot-password-container">
                            <Link to={prospectPath(prospectPages.resetPassword)}>
                                Forgot Password?
                            </Link>
                        </div>

                        <div className="prospect-auth-button-container">
                            <Button
                                text="Sign In"
                                addlClassName="btn-primary"
                                removeBoldFont={true}
                                suppressBottomMargin={true}
                                type="submit"
                            />
                        </div>

                        <FormValidationDisplay errorMessage={errorMessage} />
                    </form>
                </section>

                <section>
                    <div className="alt-page-container">
                        <span>
                            Haven't registered yet?{' '}
                            <Link
                                to={
                                    propertySlug
                                        ? tourSignupPath(propertySlug)(TourPage.Registration)
                                        : prospectPath(prospectPages.register)
                                }
                            >
                                SIGN UP
                            </Link>{' '}
                            here.
                        </span>
                    </div>
                </section>
            </Col>
        </Row>
    );
};

export default LoginPage;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/public/LoginPage.tsx